import { getAccessToken, getProfile } from '@/utils/tokenStore';
import apiInstance from "@/axios";
import workOrderApi from "@/apis/workOrder";
import { jwtDecoder } from "@/utils/utils";

/**
 * 작업 지시서 관련 비즈니스 로직을 담당하는 서비스
 */
export class WorkOrderService {
  constructor(store) {
    this.store = store;
    this.api = workOrderApi(apiInstance, store);
  }

  /**
   * 작업 지시서 데이터 준비
   */
  prepareWorkOrderData(selectedClient, certificateInfo, workOrderData) {
    console.log("[prepareWorkOrderData] 입력 데이터 확인:", {
      selectedClient,
      certificateInfo,
      workOrderData,
    });

    const dentalLaboratoryId = jwtDecoder(
      getAccessToken()
    );

    // 기공소명 가져오기 - 여러 소스에서 시도
    let dentalLaboratoryName = "";

    // 1. Vuex store의 userInfo에서
    if (this.store.state.userInfo?.companyName) {
      dentalLaboratoryName = this.store.state.userInfo.companyName;
    }
    // 2. localStorage의 CompanyInfo에서
    else if (getProfile("CompanyInfo")) {
      try {
        const companyInfo = JSON.parse(getProfile("CompanyInfo"));
        dentalLaboratoryName = companyInfo?.name || "";
      } catch (error) {
        console.error("CompanyInfo 파싱 오류:", error);
      }
    }
    // 3. localStorage의 manufacturerNameManu에서
    else if (getProfile("manufacturerNameManu")) {
      dentalLaboratoryName = getProfile("manufacturerNameManu");
    }

    console.log("기공소 정보:", { dentalLaboratoryId, dentalLaboratoryName });
    console.log("차트번호:", certificateInfo.chartNumber);
    console.log("보철 납품일:", certificateInfo.worker?.prostheticDeliveryDate);

    if (!selectedClient || !certificateInfo || !workOrderData) {
      console.log("필수 데이터 누락:", {
        selectedClient: !!selectedClient,
        certificateInfo: !!certificateInfo,
        workOrderData: !!workOrderData,
      });
      return null;
    }

    // 제조사 정보 추출 (첫 번째 항목의 제조사 사용)
    const firstDetail = workOrderData.toothDetails?.[0];
    const manufacturer = {
      manufacturerId: firstDetail?.manufacturerId || "",
      name: firstDetail?.manufacturer || "",
    };

    // UI 카드별 구조 그대로 전송 (treatmentType, gtinCode, manufacturingDate, lotNumber 추가)
    const toothDetails = (workOrderData.toothDetails || []).map((detail) => ({
      toothNumbers: detail.toothNumbers || [],
      treatmentType: detail.treatmentType || "",
      product: detail.product || "",
      material: detail.detailSelection || "ZIRCONIA",
      stm: detail.stm || false,
      gtinCode: detail.gtinCode || "",
      lotNumber: detail.lotNumber || "",
      manufacturingDate: detail.manufacturingDate || "",
    }));

    return {
      chartNumber: certificateInfo.chartNumber || "",
      prostheticDeliveryDate:
        certificateInfo.worker?.prostheticDeliveryDate || "",
      hospital: {
        hospitalId: selectedClient._id,
        name: selectedClient.name,
        cNo: selectedClient.cNo,
        ceo: selectedClient.ceo || "",
        call: selectedClient.call || "",
      },
      patient: {
        name: certificateInfo.name,
        mobile: certificateInfo.mobile?.replace(/\D/g, "") || "",
        displayMobile: certificateInfo.mobile || "",
        email: certificateInfo.email || "",
        countryCode: certificateInfo.countryCode || "+82",
        gender: certificateInfo.gender || "",
        birthDate: certificateInfo.birthDate || "",
        surgeryDate: certificateInfo.surgeryDate || "",
      },
      worker: {
        name: certificateInfo.worker?.name || "",
        workDate: certificateInfo.worker?.workDate || "",
      },
      prosthetic: {
        prostheticType: "",
        selectedTeeth: workOrderData.selectedTeeth || [],
        manufacturer: manufacturer,
        toothDetails: toothDetails,
      },
      agreements: this.mapAgreements(certificateInfo.agreements),
      metadata: {
        channel: certificateInfo.sendChannel || "KAKAOTALK",
        locale: certificateInfo.language || "ko",
      },
      dentalLaboratoryId,
      dentalLaboratoryName,
    };
  }

  /**
   * 약관 동의 데이터 매핑
   */
  mapAgreements(agreements) {
    if (Array.isArray(agreements)) {
      // 배열 형태의 약관 데이터를 객체로 변환
      const agreementMap = {};
      agreements.forEach((agreement) => {
        if (agreement._id === "privacy")
          agreementMap.privacy = agreement.isChecked;
        if (agreement._id === "service")
          agreementMap.service = agreement.isChecked;
        if (agreement._id === "marketing")
          agreementMap.marketing = agreement.isChecked;
      });
      return agreementMap;
    }

    // 이미 객체 형태인 경우
    return {
      privacy: agreements?.privacy || false,
      service: agreements?.service || false,
      marketing: agreements?.marketing || false,
    };
  }

  /**
   * 작업 지시서 생성 API 호출
   */
  async createWorkOrder(workOrderData, onSuccess, onError) {
    try {
      console.log("=== API 호출 시작 ===");
      console.log("최종 요청 데이터:", JSON.stringify(workOrderData, null, 2));

      const response = await this.api.createWorkOrder(
        workOrderData,
        onSuccess,
        onError
      );
      return response;
    } catch (error) {
      console.error("작업 지시서 생성 실패:", error);
      if (onError) onError(error);
      throw error;
    }
  }
}
